import Vue from "vue";
import Router from "vue-router";
import Index from "./views/Index.vue";
import Templates from "./views/Templates.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Profile from "./views/Profile.vue";
import Installation from "./views/Installation.vue";
import LiffActivity from "./views/liff/LiffActivity.vue";
import LineLoginCallback from "./views/LineLoginCallback.vue";
import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "index",
      components: { default: Index, header: MainNavbar, footer: MainFooter },
      props: {
        // default: { image: 'https://drive.google.com/uc?export=view&id=1EzGxcOqDO3ipJagJ2PNq2y6Q9xXtxgM6' },
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/line/callback",
      name: "lineLoginCallback",
      components: { default: LineLoginCallback, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/templates",
      name: "templates",
      components: { default: Templates, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/landing",
      name: "landing",
      components: { default: Landing, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/login",
      name: "login",
      components: { default: Login, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 }
      }
    },
    {
      path: "/profile",
      name: "profile",
      components: { default: Profile, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/installation",
      name: "installation",
      components: { default: Installation, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400, hide: true },
        footer: { backgroundColor: "black", hide: true }
      }
    },
    {
      path: "/liff/activity",
      name: "liffActivity",
      components: { default: LiffActivity, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400, hide: true },
        footer: { backgroundColor: "black", hide: true }
      }
    },
    {
      path: "/*",
      name: "all",
      components: { default: Index, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
